export default "assets/images/icons/arrow-download-065924a3.svg";